import React, { FunctionComponent } from 'react';
import styles from './Error.module.css';
import { ErrorPropTypes } from './Error';
import BoxWrapper from '../../components/BoxWrapper';
export const ErrorView: FunctionComponent<ErrorPropTypes> = (props) => {
  const { children } = props;
  return (
    <BoxWrapper>
      <div className={styles.wrapper}>{children}</div>
    </BoxWrapper>
  );
};
